import React from "react";
import _ from 'lodash';
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import {
  SectionAlternate,
  CardBase,
  Hero,
  DataListAndRowView,
} from "@components/organisms";

import { useLocation } from "react-router-dom";

//API Requests
import { ConnectService } from "@services";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
  section: {
    "& .section-alternate__content": {
      paddingTop: 0,
      marginTop: theme.spacing(-5),
      position: "relative",
      zIndex: 1,
    },
    "& .card-base__content": {
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
      },
    },
  },
}));

const SelfService = (props = {}) => {
  const classes = useStyles();

  //Set variable
  const [loading, setLoading] = React.useState(false);
  const [fetchedData, setFetchedData] = React.useState([]);

  // the query string for you.
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();

  //onPageLoad
  React.useEffect(() => {
    setLoading(true);

    let currentState = query.get("state");
    let currentCounty = query.get("county");

    ConnectService.getSelfServiceList(currentState, currentCounty)
      .then((data) => {
        setLoading(false);
        setFetchedData(_.sortBy(data.availableLinks, ['categoryTitle', 'linkTitle']));
      })
      .catch((err) => {
        alert(JSON.stringify(err));
        setLoading(false);
      });
  }, []);

  return (
    <div className={classes.root}>
      <Hero title={"Self Service"} subtitle={""} />
      <SectionAlternate className={classes.section}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <CardBase withShadow align="left">
              {/* COMPONENTS CONTENT GO HERE*/}

              <DataListAndRowView
                isLoading={loading}
                emptyStateText={"There are currently no Self Service Links to display"}
                fetchedData={fetchedData}
                mainDisplayColumns={["linkTitle"]}
                altDisplayColumn={"linkURL"}
                module="self service"
                hasFilter
              />

            </CardBase>
          </Grid>
        </Grid>
      </SectionAlternate>
    </div>
  );
};

export default SelfService;
